import React, { useState } from 'react';
import { Collapse, Box, Button } from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

export const AccordionNav = ({ title, paths }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const buttonStyle = {
    size: 'sm',
    width: 'full',
    variant: 'ghost',
    justifyContent: 'space-between',
  };

  return (
    <>
      <Button {...buttonStyle} fontWeight="medium" onClick={() => setIsOpen(!isOpen)}>
        {title}
        {isOpen ? <ChevronUpIcon boxSize={5} /> : <ChevronDownIcon boxSize={5} />}
      </Button>
      <Collapse in={isOpen}>
        <Box paddingLeft={4}>
          {paths.map(({ name, path }) => (
            <Button key={path} {...buttonStyle} fontWeight="normal" onClick={() => navigate(path)}>
              {name}
            </Button>
          ))}
        </Box>
      </Collapse>
    </>
  );
};
